module.exports = __webpack_public_path__ + "img/icon-users.2b375007.svg";